<template>
  <div class="map-kit-container" :class="{ 'color-scheme-dark': isDark }">
    <div class="map-kit-grid">
      <!-- Left panel slot -->
      <slot name="panel-left" />

      <!-- Map area (center) -->
      <div class="map-kit-primary">
        <div :id="targetId" ref="mapTarget" class="map-kit-map">
          <slot name="controls">
            <MapControls />
          </slot>
          <slot />
          <MapFooter v-if="showFooter" />
        </div>
      </div>

      <!-- Right panel slot -->
      <slot name="panel-right" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, toRefs } from 'vue';

import { useColorScheme } from '@/composables/useColorScheme';
import { useMap } from '@/composables/useMap';
import type { MapKitOptions } from '@/types';

import MapControls from './MapControls.vue';
import MapFooter from './MapFooter.vue';

const props = withDefaults(
  defineProps<{
    /** DOM id for the OL map target. */
    targetId?: string;
    /** Map initialization options. */
    options?: MapKitOptions;
    /** Show the footer bar with attributions and coordinates. */
    showFooter?: boolean;
  }>(),
  {
    targetId: 'map-kit',
    options: () => ({}),
    showFooter: true,
  },
);

const { targetId, options } = toRefs(props);

const { realColorScheme } = useColorScheme();
const isDark = computed(() => realColorScheme.value === 'dark');

const { initMap } = useMap();

onMounted(() => {
  initMap(targetId.value, options.value);
});
</script>
